import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DetailsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"details"}/>
}
